export const TermsModal = ({ onClose }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      <div className="fixed inset-0 bg-black/60 opacity-50" onClick={onClose} />
      <div className="bg-white text-black shadow-xl max-w-lg w-full p-6 relative">
        {/* Bouton de fermeture */}
        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-gray-500 hover:text-black text-xl"
        >
          &times;
        </button>

        {/* Titre */}
        <h2 className="font-poppins font-semibold text-[18px] text-title mb-4">
          Conditions générales
        </h2>

        {/* Contenu scrollable */}
        <div className="max-h-[300px] overflow-y-auto pr-2 leading-relaxed">
          <p className="font-nunito text-[14px] text-text">
            En vous inscrivant, vous acceptez nos conditions générales
            d'utilisation, incluant la politique de confidentialité, les règles
            de sécurité, et les engagements liés à la protection des données.
          </p>
          <p className="font-nunito text-[14px] text-text mt-4">
            Vous vous engagez à fournir des informations exactes et à respecter
            les règles de notre plateforme. Toute tentative de fraude ou de
            contournement des règles pourra entraîner une suspension de votre
            compte.
          </p>
          <p className="font-nunito text-[14px] text-text mt-4">
            Nous nous réservons le droit de modifier les conditions à tout
            moment. Vous serez informé des changements via l'adresse email
            associée à votre compte.
          </p>
          <p className="font-nunito text-[14px] text-text mt-4">
            Pour toute question, vous pouvez nous contacter à l'adresse
            support@barberlys.com.
          </p>
          {/* Ajoute autant de paragraphes que nécessaire */}
        </div>
      </div>
    </div>
  );
};